export type DomTomRegion = {
  code: string;
  name: string;
  isoCode: string;
};

/** Source unique des régions DOM-TOM proposées dans la sectorisation. */
export const DOM_TOM_REGIONS: readonly DomTomRegion[] = [
  { code: "971", name: "Guadeloupe", isoCode: "GP" },
  { code: "972", name: "Martinique", isoCode: "MQ" },
  { code: "973", name: "Guyane", isoCode: "GF" },
  { code: "974", name: "Réunion", isoCode: "RE" },
  { code: "975", name: "Saint-Pierre-et-Miquelon", isoCode: "PM" },
  { code: "976", name: "Mayotte", isoCode: "YT" },
  { code: "988", name: "Nouvelle-Calédonie", isoCode: "NC" },
  { code: "987", name: "Polynésie Française", isoCode: "PF" },
  { code: "986", name: "Îles Wallis-et-Futuna", isoCode: "WF" },
  {
    code: "984",
    name: "Terres Australes et Antarctiques Françaises",
    isoCode: "TF",
  },
];

const POSTAL_OVERRIDES: Record<string, DomTomRegion> = {
  "97133": { code: "977", name: "Saint-Barthélemy", isoCode: "BL" },
  "97150": { code: "978", name: "Saint-Martin", isoCode: "MF" },
  "977": { code: "977", name: "Saint-Barthélemy", isoCode: "BL" },
  "978": { code: "978", name: "Saint-Martin", isoCode: "MF" },
  "989": { code: "989", name: "Polynésie Française", isoCode: "PF" },
};

export function getDomTomRegionFromPostalCode(
  postalCode: string | null | undefined,
): DomTomRegion | null {
  const normalizedPostalCode = String(postalCode ?? "").replace(/\s/g, "");
  if (!/^\d{5}$/.test(normalizedPostalCode)) return null;

  const exactMatch = POSTAL_OVERRIDES[normalizedPostalCode];
  if (exactMatch) return exactMatch;

  const prefix = normalizedPostalCode.slice(0, 3);
  return (
    POSTAL_OVERRIDES[prefix] ??
    DOM_TOM_REGIONS.find((region) => region.code === prefix) ??
    null
  );
}

export function getDomTomNameFromPostalCode(
  postalCode: string | null | undefined,
): string | null {
  return getDomTomRegionFromPostalCode(postalCode)?.name ?? null;
}

export function getDomTomIsoFromPostalCode(
  postalCode: string | null | undefined,
): string | null {
  return getDomTomRegionFromPostalCode(postalCode)?.isoCode ?? null;
}

export function hasDomTomCountryWithMetropolitanPostalCode(
  countryLabel: string | null | undefined,
  postalCode: string | null | undefined,
): boolean {
  const normalizedCountry = String(countryLabel ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase();
  const normalizedPostalCode = String(postalCode ?? "").replace(/\s/g, "");

  return (
    normalizedCountry.includes("FRANCE DOM/TOM") &&
    /^\d{5}$/.test(normalizedPostalCode) &&
    getDomTomRegionFromPostalCode(normalizedPostalCode) === null
  );
}
